import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { PHONG_HOP_PREFIX_URL } from './constants/config.phong-hop'

const ListPagePhongHop = lazy(() => import('./pages/ListPage.PhongHop'))

const PhongHopRouter: AppRouterItem[] = [
  {
    path: PHONG_HOP_PREFIX_URL,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPagePhongHop />
      </LoadingLazyComponents>
    ),
  },
]

export default PhongHopRouter
